'use client';

import { formatString } from '../../../../../utils/string-utils';

interface TableRowProps {
  assetType: string;
  amountOfAssets: number;
  availableToClaim: number;
}

export const TableRow: React.FC<TableRowProps> = ({
  assetType,
  amountOfAssets,
  availableToClaim,
}) => {
  return (
    <tr className='text-xs font-medium tracking-wider text-white/80 md:text-lg'>
      <td className='px-2 py-2 text-left md:px-4'>
        {amountOfAssets.toLocaleString()}
      </td>
      <td className='px-2 py-2 text-left capitalize md:px-4'>
        {formatString(assetType)}
      </td>
      <td className='px-2 py-2 text-right md:px-4'>
        {availableToClaim.toLocaleString()}
      </td>
    </tr>
  );
};
